<template>
    <input
        ref="input"

        type="text"
        class="border border-gray-200 p-4 text-base rounded size-[67px] text-center font-caption focus-outline-only"
        :placeholder="placeholder"
        :aria-label="label"

        :value="value"

        maxlength="1"

        @keydown="handleKeydown"
        @input="handleInput('first', $event)"
        @click="handleClick($event)"

        @focus="onFocus"
        @blur="onBlur"
    />
</template>

<script>
    export default {
        props: {
            index: Number,
            label: String,
            placeholder: String,
            value: String,
        },

        emits: ['focus', 'blur', 'input', 'back'],

        methods: {
            onFocus() {
                this.$emit('focus');
            },

            onBlur() {
                this.$emit('blur');
            },

            handleInput(field, event) {
                const value = event.target.value;

                const lastChar = value.slice(-1);

                this.$emit('input', lastChar);
            },

            handleKeydown(event) {
                if (event.key === 'Backspace') {
                    if (this.value === '') {
                        // Next tick cause we need the event to be eaten by this control.
                        setTimeout(() => {
                            this.$emit('back');
                        }, 10);
                    }
                }
            },

            handleClick(event) {
                event.target.select();
            },

            focus() {
                if (this.$refs.input) {
                    this.$refs.input.focus();
                    this.$refs.input.select();
                }
            },
        },
    };
</script>
